import { Box, ButtonLink, Card, CardBody, Flex, Text } from '@backstage/ui';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { HOMEPAGE_EXTERNAL_LINKS } from './links';

export const EmuMigrationCard = () => (
  <Card style={{ background: 'var(--bui-bg-info)', border: '1px solid var(--bui-border-info)' }}>
    <CardBody style={{ padding: 0 }}>
      <Box py="12" px="6">
        <Flex direction="column" gap="8" align="start">
          <Flex direction="column" gap="1">
            <Text as="h3" variant="title-medium" weight="bold">
              GitHub EMU migration
            </Text>
            <Text variant="body-medium">
              Check your application's migration readiness and get ready for the migration.
            </Text>
          </Flex>
          <Flex gap="2" align="center" style={{ flexWrap: 'wrap' }}>
            <ButtonLink
              href="/emu-migration"
              variant="primary"
              size="medium"
              iconEnd={<ArrowForwardIcon fontSize="small" />}
            >
              View migration dashboard
            </ButtonLink>
            <ButtonLink
              href={HOMEPAGE_EXTERNAL_LINKS.emuMigrationDocs}
              target="_blank"
              rel="noopener noreferrer"
              variant="tertiary"
              size="medium"
              style={{ color: 'var(--bui-bg-solid)' }}
              aria-label="About EMU migration (opens in new tab)"
              iconEnd={<OpenInNewIcon fontSize="small" aria-hidden />}
            >
              About EMU migration
            </ButtonLink>
          </Flex>
        </Flex>
      </Box>
    </CardBody>
  </Card>
);
